
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import DZModelDicConfig from "@/model/DZModelDicConfig";
import DZModelDemandBase from "@/views/审核管理/model/DZModelDemandBase";
import nyMessageToast from "@/utils/NYMessageToast";
import nyNetwork from "@/api/nyBaseNetwork";

@Component
export default class Base extends Vue {

  rules = {
    title: [{ required: true, message: '请输入需求标题', trigger: 'blur' }],
    bigType: [{ required: true, message: '请选择土地大类', trigger: 'blur' }],
    smallType: [{ required: true, message: '请选择土地小类', trigger: 'blur' }],
    movePeriod: [{ required: true, message: '请输入流转年限', trigger: 'blur' }],
    moverType: [{ required: true, message: '请选择流转类型', trigger: 'blur' }],
    priceFrom: [{ required: true, message: '请输入期望价格', trigger: 'blur' }],
    priceTo: [{ required: true, message: '请输入期望价格', trigger: 'blur' }],
    describe: [{ required: true, message: '请输入补充说明', trigger: 'blur' }],
  }

  @Prop() data;

  @Prop() dic;

  flag = true

  m_base = new DZModelDemandBase();

  dic_config = new DZModelDicConfig();

  /** 流转类型 **/
  list_moverType = []

  /** 土地大类 **/
  list_bigType = []
  getBigType() {
    nyNetwork.net("标签获取字典分类", { label: '10001' }, data => {
      this.list_bigType = data
    })
  }
  getSmallType(id) {
    this.m_base.smallType = ''
    nyNetwork.get("字典列表查询", { id: id }, data => {
      this.list_smallType = data
    })
  }
  /** 土地小类 **/
  list_smallType = []

  created() {
    this.getBigType()
  }

  mounted() { }

  @Watch("data")
  watchData(value: any, oldValue: string) {
    if (value) {
      this.m_base = value;
      console.log("this.m_base====", this.m_base)
      if (this.m_base.bigType) {
        nyNetwork.get("字典列表查询", { id: this.m_base.bigType }, data => {
          this.list_smallType = data
        })
      }
    }
  }
  @Watch("dic")
  watchDic(value: any, oldValue: string) {
    if (value) {
      value.forEach(d => {
        if (d.typeId == this.dic_config.get("流转类型")) {
          this.list_moverType = d.dicList
        }
      })
    }
  }

  handle_edit() {
    this.flag = !this.flag
  }

  handle_submit() {
    // @ts-ignore
    this.$refs.form.validate(v => {
      if (v) {
        this.$emit('ny_submit', this.m_base)
        this.handle_edit()
      } else {
        nyMessageToast.warning("请输入必填项")
        return false
      }
    })

  }
}
